import styled from 'styled-components';

import { cssBreakpoints, gutterWidth } from 'theme/theme';

const listingBodyHorizontalPadding = '--listing-layout-horizontal-padding';

export const ListingViewBodyHolder = styled.div`
  max-width: ${1920 - 500}px;
  margin: 0 auto;
  position: relative;
  display: flex;
  padding-left: var(${listingBodyHorizontalPadding});
  padding-right: var(${listingBodyHorizontalPadding});
  font-size: 16px;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    ${listingBodyHorizontalPadding}: ${gutterWidth / 2}px;
    font-size: 14px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) and (max-width: ${cssBreakpoints.lgDown}) {
    gap: 40px;
    ${listingBodyHorizontalPadding}: 30px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    gap: 80px;
    ${listingBodyHorizontalPadding}: 44px;
  }

  .idlst-rchtxt {
    font-size: 16px;
  }
`;
